export default __webpack_public_path__ + "static/Riccardo-09c506cd1d21b31d62ce7188e6a0d6de.jpg";